




















import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class AuditLogList extends Vue {
  @Prop({ default: '' }) public auditName: string;
  @Prop({ default: '' }) public auditNo: string;

  public items: Common.AuditLog[] = new Array();
  public isLoading: boolean = false;

  public auditItems: Common.AuditItem[] = new Array();
  public ownLink:string = "";

  created() {
    this.$api.formatter.ensureListLoaded("auditSources").then(()=>{
      this.setOwnLink();
    });
  }
  mounted() {
    this.loadAuditLog();
  }

  setOwnLink(){
      this.ownLink = String.format(this.$api.formatter.formatByList(this.auditName, "auditSources"),this.auditNo);
  }
  //#region
  @Watch('auditName')
  onAuditNameChanged() {
    this.loadAuditLog();
    this.setOwnLink();
  }
  @Watch('auditNo')
  onAuditNoChanged() {
    this.loadAuditLog();
    this.setOwnLink();    
  }

  loadAuditLog() {
    this.auditItems = new Array();
    this.items = new Array();
    //auditLogをロードする

    if (this.auditName && this.auditNo){
      const query = new Common.AuditLogQuery();
      query.auditName = this.auditName;
      query.auditNo = this.auditNo;
      query.editorMode = true;
      query.isDescending = true;
      query.perPage = 0; //フルロード
      this.isLoading = true;

      this.$api.execute(query).then(obj => {
        this.items = (obj as Common.LoadResult).result;
        this.isLoading = false;
        //以下は$refsがundefinedでエラーが発生するためコメント。グリッド側で最初の行が選択されるので不要。
        // if (this.items.length > 0) (this.$refs.parentList as Components.Grid).select(0);

      });      
    }
  }

  onSelected(index: number) {
    this.auditItems = this.items[index].auditItems;
  }
}
